// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/CourierModal/pages/styles/FailurePage.module.css */

.FailurePage_container__q8qjd {
padding-top: 10px;
padding-left: 10px;
padding-right: 10px;

}

/* Заголовок */
.FailurePage_title__EO6dU {
  font-size: 20px;
  margin-bottom: 15px;
  text-align: center;

}

/* Сетка кнопок категорий (стартовая страница) */
.FailurePage_grid__XCuGK {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Базовый стиль кнопки категории */
.FailurePage_categoryBtn__rBea4 {
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  font-weight: 500;
  color: #fff;
  transition: filter 0.2s ease;
}

/* Градиентные фоны для каждой категории */
.FailurePage_client__W7ROO {
  background: linear-gradient(90deg, #6bb5fb 0%, #4dabf7 100%);
}
.FailurePage_invalidOrder__jXzKx {
  background: linear-gradient(90deg, #55a8f8 0%, #339af0 100%);
}
.FailurePage_reschedule__1tc6t {
  background: linear-gradient(90deg, #3c9feb 0%, #228be6 100%);
}
.FailurePage_timeLimit__RPjph {
  background: linear-gradient(90deg, #2a8deb 0%, #1c7ed6 100%);
}
.FailurePage_technical__hdlWC {
  background: linear-gradient(90deg, #2676c4 0%, #1971c2 100%);
}

.FailurePage_categoryBtn__rBea4:hover {
  filter: brightness(1.1);
}

/* Кнопка «Другая причина…» (мануальный ввод) */
.FailurePage_manualBtn__QhjLJ {
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #f1f3f5;
  color: #212529;
  transition: background-color 0.2s ease;
  text-align: left;
  font-weight: 500;
}
.FailurePage_manualBtn__QhjLJ:hover {
  background-color: #e9ecef;
}

/* Кнопка «Отмена» (начало и при выборе опций) */
.FailurePage_cancelBtn__mKETA {
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #dee2e6;
  color: #212529;
  transition: background-color 0.2s ease;
}
.FailurePage_cancelBtn__mKETA:hover {
  background-color: #ced4da;
}


/* Список опций выбранной категории */
.FailurePage_list__lMSvD {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Кнопки опций (шаг 2) */
.FailurePage_optionBtn__KOlPA {
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #339af0;
  color: #fff;
  text-align: left;
  font-weight: 500;
  transition: filter 0.2s ease;
}
.FailurePage_optionBtn__KOlPA:hover {
  filter: brightness(1.1);
}

/* Скрытый элемент time-пикера */
.FailurePage_hiddenTime__fZCuq {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* Текстовое поле для ручного ввода */
.FailurePage_textarea__OTQWa {
  width: 100%;
  min-height: 80px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  resize: vertical;
}

/* Футер со «Назад» и «Отмена» или «Подтвердить» */
.FailurePage_footer__es7eC {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  gap: 8px;
}

/* Кнопка «Назад» */
.FailurePage_backBtn__mgx1W {
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #dee2e6;
  color: #212529;
  transition: background-color 0.2s ease;
}
.FailurePage_backBtn__mgx1W:hover {
  background-color: #ced4da;
}

/* Кнопка «Подтвердить» (ручной ввод) */
.FailurePage_confirmBtn__4Yflv {
  margin-top: 12px;
  padding: 10px 16px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #339af0;
  color: #fff;
  transition: background-color 0.2s ease;
}
.FailurePage_confirmBtn__4Yflv:hover {
  background-color: #1c7ed6;
}
.FailurePage_confirmBtn__4Yflv:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Кнопка «Отмена» */
.FailurePage_cancelBtn__mKETA,
.FailurePage_backBtn__mgx1W {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #dee2e6;
  color: #212529;
  transition: background-color 0.2s ease;
  /* убираем margin-top */
  margin-top: 0;
}

.FailurePage_cancelBtn__mKETA:hover,
.FailurePage_backBtn__mgx1W:hover {
  background-color: #ced4da;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/FailurePage.module.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;AACA,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;;AAEnB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;;AAEA;EACE,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;;;AAGA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;;EAEE,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sCAAsC;EACtC,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":["/* src/modules/Courier/pages/CourierModal/pages/styles/FailurePage.module.css */\r\n\r\n.container {\r\npadding-top: 10px;\r\npadding-left: 10px;\r\npadding-right: 10px;\r\n\r\n}\r\n\r\n/* Заголовок */\r\n.title {\r\n  font-size: 20px;\r\n  margin-bottom: 15px;\r\n  text-align: center;\r\n\r\n}\r\n\r\n/* Сетка кнопок категорий (стартовая страница) */\r\n.grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* Базовый стиль кнопки категории */\r\n.categoryBtn {\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  font-weight: 500;\r\n  color: #fff;\r\n  transition: filter 0.2s ease;\r\n}\r\n\r\n/* Градиентные фоны для каждой категории */\r\n.client {\r\n  background: linear-gradient(90deg, #6bb5fb 0%, #4dabf7 100%);\r\n}\r\n.invalidOrder {\r\n  background: linear-gradient(90deg, #55a8f8 0%, #339af0 100%);\r\n}\r\n.reschedule {\r\n  background: linear-gradient(90deg, #3c9feb 0%, #228be6 100%);\r\n}\r\n.timeLimit {\r\n  background: linear-gradient(90deg, #2a8deb 0%, #1c7ed6 100%);\r\n}\r\n.technical {\r\n  background: linear-gradient(90deg, #2676c4 0%, #1971c2 100%);\r\n}\r\n\r\n.categoryBtn:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n/* Кнопка «Другая причина…» (мануальный ввод) */\r\n.manualBtn {\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  background-color: #f1f3f5;\r\n  color: #212529;\r\n  transition: background-color 0.2s ease;\r\n  text-align: left;\r\n  font-weight: 500;\r\n}\r\n.manualBtn:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n/* Кнопка «Отмена» (начало и при выборе опций) */\r\n.cancelBtn {\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  background-color: #dee2e6;\r\n  color: #212529;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.cancelBtn:hover {\r\n  background-color: #ced4da;\r\n}\r\n\r\n\r\n/* Список опций выбранной категории */\r\n.list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* Кнопки опций (шаг 2) */\r\n.optionBtn {\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  background-color: #339af0;\r\n  color: #fff;\r\n  text-align: left;\r\n  font-weight: 500;\r\n  transition: filter 0.2s ease;\r\n}\r\n.optionBtn:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n/* Скрытый элемент time-пикера */\r\n.hiddenTime {\r\n  position: absolute;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Текстовое поле для ручного ввода */\r\n.textarea {\r\n  width: 100%;\r\n  min-height: 80px;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  resize: vertical;\r\n}\r\n\r\n/* Футер со «Назад» и «Отмена» или «Подтвердить» */\r\n.footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 8px;\r\n  gap: 8px;\r\n}\r\n\r\n/* Кнопка «Назад» */\r\n.backBtn {\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  background-color: #dee2e6;\r\n  color: #212529;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.backBtn:hover {\r\n  background-color: #ced4da;\r\n}\r\n\r\n/* Кнопка «Подтвердить» (ручной ввод) */\r\n.confirmBtn {\r\n  margin-top: 12px;\r\n  padding: 10px 16px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  background-color: #339af0;\r\n  color: #fff;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.confirmBtn:hover {\r\n  background-color: #1c7ed6;\r\n}\r\n.confirmBtn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Кнопка «Отмена» */\r\n.cancelBtn,\r\n.backBtn {\r\n  width: 100%;\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  background-color: #dee2e6;\r\n  color: #212529;\r\n  transition: background-color 0.2s ease;\r\n  /* убираем margin-top */\r\n  margin-top: 0;\r\n}\r\n\r\n.cancelBtn:hover,\r\n.backBtn:hover {\r\n  background-color: #ced4da;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FailurePage_container__q8qjd`,
	"title": `FailurePage_title__EO6dU`,
	"grid": `FailurePage_grid__XCuGK`,
	"categoryBtn": `FailurePage_categoryBtn__rBea4`,
	"client": `FailurePage_client__W7ROO`,
	"invalidOrder": `FailurePage_invalidOrder__jXzKx`,
	"reschedule": `FailurePage_reschedule__1tc6t`,
	"timeLimit": `FailurePage_timeLimit__RPjph`,
	"technical": `FailurePage_technical__hdlWC`,
	"manualBtn": `FailurePage_manualBtn__QhjLJ`,
	"cancelBtn": `FailurePage_cancelBtn__mKETA`,
	"list": `FailurePage_list__lMSvD`,
	"optionBtn": `FailurePage_optionBtn__KOlPA`,
	"hiddenTime": `FailurePage_hiddenTime__fZCuq`,
	"textarea": `FailurePage_textarea__OTQWa`,
	"footer": `FailurePage_footer__es7eC`,
	"backBtn": `FailurePage_backBtn__mgx1W`,
	"confirmBtn": `FailurePage_confirmBtn__4Yflv`
};
export default ___CSS_LOADER_EXPORT___;
